import { US_STATES, type UsStateName } from '@nesso/common-contracts/us-states';

export type UsStateOption = { value: UsStateName; label: UsStateName };

export const US_STATE_OPTIONS: UsStateOption[] = US_STATES.map(([, name]) => ({
    value: name,
    label: name,
}));
